var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.4,
    height: 63.4,
    viewBox: "0 0 63.4 63.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d93025;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.7,0A31.7,31.7,0,1,0,63.4,31.7,31.682,31.682,0,0,0,31.7,0Zm0,58.447A26.747,26.747,0,1,1,58.447,31.7,26.732,26.732,0,0,1,31.7,58.447Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.049 20.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M185.126,181.6l-7.394-7.394,7.394-7.394a2.494,2.494,0,1,0-3.526-3.526l-7.394,7.394-7.394-7.394a2.494,2.494,0,1,0-3.526,3.526l7.394,7.394-7.394,7.394a2.494,2.494,0,1,0,3.526,3.526l7.394-7.394,7.394,7.394a2.494,2.494,0,1,0,3.526-3.526Z",
    transform: "translate(-162.555 -162.556)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFailed);
export default __webpack_public_path__ + "static/media/ic-failed.1b70a12d.svg";
export { ForwardRef as ReactComponent };